import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {ContractCounter} from '@/model/resource/ContractCounter'
import {DappDetailedGraphPeriod} from '@/enums/DappDetailedGraphPeriod'

@HttpExclude()
export class ContractCounterCollection extends ExpansibleCollection<
  ContractCounter
> {
  resource?: IContractCounterCollectionResourcesHolder

  @RequestExpose() idContractFk: number[] = []
  @RequestExpose() interval: DappDetailedGraphPeriod =
    DappDetailedGraphPeriod.SEVEN_DAYS
  @RequestExpose() startDate: string | null = null
  @RequestExpose() endDate: string | null = null
  @RequestExpose() isReference: boolean = false

  constructor() {
    super(ContractCounter)
  }

  async listDailyContractCounter(): Promise<any> {
    return await Request.get(`/client/contract-counter/daily`, {
      params: this.params,
    })
      .name('listDailyContractCounter')
      .as(this)
      .getData()
  }

  async listHourlyContractCounter(): Promise<any> {
    return await Request.get(`/client/contract-counter/hourly`, {
      params: this.params,
    })
      .name('listHourlyContractCounter')
      .as(this)
      .getData()
  }

  async getTotalTransactionCount(): Promise<number> {
    const data = await Request.get(`/client/contract-counter/total`, {
      params: this.params,
    })
      .name('getTotalTransactionCount')
      .asAny()
      .getData()
    return Number(data?.totalTransactionCount ?? 0)
  }

  queryAsPage(): Promise<any> {
    return this.listHourlyContractCounter()
  }
}

export type ContractCounterBatchDailyRow = {
  idContractFk: number
  createdAt: string
  transactionCount: number
}

export type ContractCounterBatchTotalRow = {
  idContractFk: number
  totalTransactionCount: number
}

export type ContractCounterBatchResponse = {
  daily: ContractCounterBatchDailyRow[]
  totals: ContractCounterBatchTotalRow[]
}

export type ContractCounterDappBatchDailyRow = {
  idDappFk: number
  createdAt: string
  transactionCount: number
}

export type ContractCounterDappBatchTotalRow = {
  idDappFk: number
  totalTransactionCount: number
}

export type ContractCounterDappBatchResponse = {
  daily: ContractCounterDappBatchDailyRow[]
  totals: ContractCounterDappBatchTotalRow[]
}

/** One POST for daily rows + per-contract all-time totals (up to 500 ids). */
export async function postBatchContractCounters(payload: {
  idContractFk: number[]
  interval: number
  isReference: boolean
}): Promise<ContractCounterBatchResponse> {
  return await Request.post(`/client/contract-counter/batch`, payload)
    .name('postBatchContractCounters')
    .asAny()
    .getData()
}

/** One POST for daily + all-time totals aggregated per dApp (up to 200 ids). */
export async function postBatchContractCountersByDapp(payload: {
  idDappFk: number[]
  interval: number
  isReference: boolean
}): Promise<ContractCounterDappBatchResponse> {
  return await Request.post(`/client/contract-counter/batch-by-dapp`, payload)
    .name('postBatchContractCountersByDapp')
    .asAny()
    .getData()
}

export interface IContractCounterCollectionResourcesHolder {}
